// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AnswerS3FileViewer-module__answerS3FileViewer__mIqOe {
  display: flex;
  align-items: center;
  width: 100%;
}
.AnswerS3FileViewer-module__answerS3FileViewerText__PUPX_ {
  cursor: pointer;
  color: #07a6f3;
  max-width: 300px;
  padding-right: 3px;
}
.AnswerS3FileViewer-module__answerS3FileViewerText__PUPX_:hover {
  color: #26bbf0;
}
.AnswerS3FileViewer-module__s3FactTableContainer__W2g1a {
  display: flex;
  align-items: center;
  justify-content: center;
}
.AnswerS3FileViewer-module__s3FactTableButtonContainer__mCP3f {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 8px;
}
.AnswerS3FileViewer-module__tableFactTableContainer__ZUUNw {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
}
.AnswerS3FileViewer-module__fileButton__Qh3UB {
  height: 32px;
  border-radius: 4px;
  border: 1px solid #d9d9d9;
  color: rgba(0, 0, 0, 0.85);
  cursor: pointer;
  display: flex;
  padding: 4px 8px;
  align-items: center;
  gap: 4px;
  flex: 1 0 0;
  margin-right: 8px;
}
.AnswerS3FileViewer-module__fileButton__Qh3UB:hover {
  border: 1px solid #b37feb;
  background: #efdbff;
}
.AnswerS3FileViewer-module__filePreviewContainer__yI5fM {
  padding: 30px 6px 0 6px;
  width: 100%;
}
.AnswerS3FileViewer-module__filePreviewHeader__aH_1k {
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px;
}
.AnswerS3FileViewer-module__expandContainer__Wucs7 {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.AnswerS3FileViewer-module__downloadButton__kPSko {
  color: rgba(0, 0, 0, 0.85);
  cursor: pointer;
  margin-right: 12px;
}
.AnswerS3FileViewer-module__title__NqU71 {
  display: flex;
  align-items: center;
}
.AnswerS3FileViewer-module__previewIcons__aW6Wc {
  display: flex;
  align-items: center;
}
.AnswerS3FileViewer-module__s3FactIcon__MaIfF {
  height: 20px;
  width: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/components/AnswerS3FileViewer.module.less"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AADF;AAIA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AAFF;AAIE;EACE,cAAA;AAFJ;AAMA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAJF;AAOA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,kBAAA;AALF;AAQA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AANF;AASA;EACE,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,0BAAA;EACA,eAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;EACA,iBAAA;AAPF;AAUA;EACE,yBAAA;EACA,mBAAA;AARF;AAWA;EACE,uBAAA;EACA,WAAA;AATF;AAYA;EACE,0BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAVF;AAaA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAXF;AAcA;EACE,0BAAA;EACA,eAAA;EACA,kBAAA;AAZF;AAeA;EACE,aAAA;EACA,mBAAA;AAbF;AAgBA;EACE,aAAA;EACA,mBAAA;AAdF;AAiBA;EACE,YAAA;EACA,WAAA;AAfF","sourcesContent":["@import '@css/variables.less';\n\n.answerS3FileViewer {\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n\n.answerS3FileViewerText {\n  cursor: pointer;\n  color: @color-link-blue;\n  max-width: 300px;\n  padding-right: 3px;\n\n  &:hover {\n    color: @color-link-blue-hover;\n  }\n}\n\n.s3FactTableContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.s3FactTableButtonContainer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  margin-bottom: 8px;\n}\n\n.tableFactTableContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 8px;\n}\n\n.fileButton {\n  height: 32px;\n  border-radius: 4px;\n  border: 1px solid #d9d9d9;\n  color: rgba(0, 0, 0, 0.85);\n  cursor: pointer;\n  display: flex;\n  padding: 4px 8px;\n  align-items: center;\n  gap: 4px;\n  flex: 1 0 0;\n  margin-right: 8px;\n}\n\n.fileButton:hover {\n  border: 1px solid #b37feb;\n  background: #efdbff;\n}\n\n.filePreviewContainer {\n  padding: 30px 6px 0 6px;\n  width: 100%;\n}\n\n.filePreviewHeader {\n  color: rgba(0, 0, 0, 0.85);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 22px;\n}\n\n.expandContainer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.downloadButton {\n  color: rgba(0, 0, 0, 0.85);\n  cursor: pointer;\n  margin-right: 12px;\n}\n\n.title {\n  display: flex;\n  align-items: center;\n}\n\n.previewIcons {\n  display: flex;\n  align-items: center;\n}\n\n.s3FactIcon {\n  height: 20px;\n  width: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"answerS3FileViewer": `AnswerS3FileViewer-module__answerS3FileViewer__mIqOe`,
	"answerS3FileViewerText": `AnswerS3FileViewer-module__answerS3FileViewerText__PUPX_`,
	"s3FactTableContainer": `AnswerS3FileViewer-module__s3FactTableContainer__W2g1a`,
	"s3FactTableButtonContainer": `AnswerS3FileViewer-module__s3FactTableButtonContainer__mCP3f`,
	"tableFactTableContainer": `AnswerS3FileViewer-module__tableFactTableContainer__ZUUNw`,
	"fileButton": `AnswerS3FileViewer-module__fileButton__Qh3UB`,
	"filePreviewContainer": `AnswerS3FileViewer-module__filePreviewContainer__yI5fM`,
	"filePreviewHeader": `AnswerS3FileViewer-module__filePreviewHeader__aH_1k`,
	"expandContainer": `AnswerS3FileViewer-module__expandContainer__Wucs7`,
	"downloadButton": `AnswerS3FileViewer-module__downloadButton__kPSko`,
	"title": `AnswerS3FileViewer-module__title__NqU71`,
	"previewIcons": `AnswerS3FileViewer-module__previewIcons__aW6Wc`,
	"s3FactIcon": `AnswerS3FileViewer-module__s3FactIcon__MaIfF`
};
export default ___CSS_LOADER_EXPORT___;
